import React from 'react';

import Row from 'components/Row';
import List from 'components/List';
import ListItem from 'components/ListItem';
import TextWithIcon from 'components/TextWithIcon';
import Link from 'components/Link';
import Button from 'components/ButtonDeprecated';
import LinkConstants from 'constants/LinkConstants';
import CoachingScheduleInstanceDescription from './CoachingScheduleInstanceDescription';
import { InstanceTextBadge } from 'coaching/components/CoachingHomeView/CoachingSessionInstanceRowComponents';
import { GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach } from 'coaching/queries/__generated__/GetCoachDashboardScheduleInstances';

export type InstanceRowComponentProps = GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach & {
  onClickMessage?: () => void;
};

export default function CoachingScheduleSessionRowStacked(props: InstanceRowComponentProps) {
  const {
    startDateTime,
    endDateTime,
    participant,
    sessionSchedule,
    cancelled,
    cancelledLate,
    added,
  } = props;

  const streamUuid = participant?.sessionTools?.stream?.uuid;

  return (
    <Row size="xsmall">
      <List data-test="coaching-schedule-stacked-list" size="medium">
        <ListItem data-test="coaching-schedule-stacked-item">
          <CoachingScheduleInstanceDescription
            startDateTime={startDateTime}
            endDateTime={endDateTime}
            participantName={participant?.studentName ?? ''}
            subjectName={sessionSchedule?.subject?.name}
            studentGradeLevel={participant?.studentGradeLevel}
            isCancelled={cancelled}
          />
        </ListItem>
        <ListItem data-test="coaching-schedule-stacked-item">
          <InstanceTextBadge
            textBadgeTextColorCancellation="apple"
            colorBadgeCancellation="apple-lightest"
            isLateCancelled={cancelledLate}
            isCancelled={cancelled}
            isPartOfRecurringSchedule={!added}
            userHasNoRecurringSchedules={!added}
          />
        </ListItem>
        <ListItem data-test="coaching-schedule-stacked-item">
          {streamUuid && (
            <Link
              color="chalkboard"
              data-test="coaching-schedule-session-stream"
              href={`${LinkConstants.MOBILE_WEB_CHAT_LINK}/${streamUuid}?tutoring=true`}
              weight="semibold"
              target="_blank">
              <Button size="xxsmall" level="secondary" color="chalkboard">
                <TextWithIcon icon="message" iconSize="medium" size="small">
                  Message
                </TextWithIcon>
              </Button>
            </Link>
          )}
        </ListItem>
      </List>
    </Row>
  );
}
